<script>
import animation from '../partials/components/animate.vue';
import magnetic from '../partials/components/Magnetic.vue';
import hero from '../partials/modules/Hero.vue';
import articlesFilter from '../partials/components/articles-filter.vue';
import pagination from '../partials/components/pagination.vue';
import wavyLine from '../partials/components/wavy-line.vue';
import searchRiverwatch from '../partials/components/search-form.vue';
import newsletter from '../partials/modules/newsletter.vue';
import parallaxBg from '../partials/components/ParallaxBg.vue';
import zoomIn from '../partials/components/animations/ZoomIn.vue';

export default {
    components: {
        animation,
        magnetic,
        hero,
        articlesFilter,
        pagination,
        wavyLine,
        searchRiverwatch,
        newsletter,
        parallaxBg,
        zoomIn
    }
};
</script>
